import { render, staticRenderFns } from "./CreateEditSpecification.vue?vue&type=template&id=a2305d64&"
import script from "./CreateEditSpecification.vue?vue&type=script&lang=js&"
export * from "./CreateEditSpecification.vue?vue&type=script&lang=js&"
import style0 from "./CreateEditSpecification.vue?vue&type=style&index=0&id=a2305d64&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports